import { render, staticRenderFns } from "./FormInputCreator.vue?vue&type=template&id=0b87e36e&scoped=true&"
import script from "./FormInputCreator.vue?vue&type=script&lang=js&"
export * from "./FormInputCreator.vue?vue&type=script&lang=js&"
import style0 from "./FormInputCreator.vue?vue&type=style&index=0&id=0b87e36e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87e36e",
  null
  
)

export default component.exports